import { RouterProvider } from "react-router-dom";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { huHU } from '@mui/x-date-pickers/locales';
// Registers the Hungarian locale without making it dayjs's global one: only the pickers use it.
import 'dayjs/locale/hu';
import router from './routes/AppRouter';
import { SnackbarProvider } from './contexts/SnackBarContext';
import { TenantProvider } from './contexts/TenantContext';
import DynamicThemeProvider from './providers/DynamicThemeProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
    },
  },
});
  
const App = () => {
  return (
     <QueryClientProvider client={queryClient}>
      <TenantProvider>
        {/* Hungarian month and day names, a week starting on Monday, Hungarian button labels. */}
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale="hu"
          localeText={huHU.components.MuiLocalizationProvider.defaultProps.localeText}
        >
          <SnackbarProvider>
              <DynamicThemeProvider>
                  <RouterProvider router={router} />
              </DynamicThemeProvider>
          </SnackbarProvider>
        </LocalizationProvider>
      </TenantProvider>
     </QueryClientProvider>
  );
}

export default App;
